export default __webpack_public_path__ + "static/coloradosprings-a2ca2de27fdb4c3ce7d5372c1e27951c.png";